import { SVGProps } from 'react';

export const ShortArrow = (props: { className?: string } & SVGProps<SVGSVGElement>) => (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M5.83203 13.9999H22.1654M22.1654 13.9999L13.9987 5.83325M22.1654 13.9999L13.9987 22.1666"
      stroke="currentcolor"
      strokeWidth="2.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
